module.exports = __webpack_public_path__ + "img/paysafe.c02d868f.svg";